import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config";

import TicketDetails from "./TicketDetails";
import TicketStatusUpdate from "./TicketStatusUpdate";
import TicketComments from "./TicketComments";
import TicketFiles from "./TicketFiles";
import TicketLogs from "./TicketLogs";
import WorkOrderList from "./TicketWorkOrder"; // ✅ FIXED

const TicketView = () => {
  const { id } = useParams();

  const [activeTab, setActiveTab] = useState("details");

  const [ticket, setTicket] = useState(null);
  const [assetList, setAssetList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [resolutionList, setResolutionList] = useState([]);

  const [workOrders, setWorkOrders] = useState([]); // ✅ FIXED

  const getAuthHeader = () => {
    const token = localStorage.getItem("authToken");
    return { Authorization: `Bearer ${token}` };
  };

  const loadDetails = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/tickets/${id}/details`,
        { headers: getAuthHeader() }
      );

      setTicket(res.data.ticket);
      setAssetList(res.data.asset_list || []);
      setStatusList(res.data.status_list || []);
      setResolutionList(res.data.resolution_list || []);
    } catch (err) {
      console.error("Error loading ticket details", err);
    }
  };

  const loadWorkOrders = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/tickets/${id}/workorder`,
        { headers: getAuthHeader() }
      );
      setWorkOrders(res.data || []); // ✅ FIXED
    } catch (err) {
      console.error("Error loading work orders", err);
    }
  };

  useEffect(() => {
    loadDetails();
    loadWorkOrders();
  }, [id]);

  if (!ticket) return <div className="p-4">Loading...</div>;

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Ticket: {ticket.ticket_code}</h3>

      <div className="row">
        {/* LEFT SIDE */}
        <div className="col-md-4">
          <div className="card shadow-sm">
            <div className="card-header">
              <h5 className="mb-0">Ticket Information</h5>
            </div>

            <table className="table m-0">
              <tbody>
                <tr><th>SUBJECT</th><td>{ticket.subject}</td></tr>
                <tr><th>ASSET</th><td>{ticket.asset_name}</td></tr>
                <tr><th>REPORTED BY</th><td>{ticket.reported_by_name}</td></tr>
                <tr><th>HELPDESK</th><td>{ticket.helpdesk}</td></tr>
                <tr><th>ASSIGN TO</th><td>{ticket.assigned_name}</td></tr>
                <tr><th>PRIORITY</th><td>{ticket.priority_title}</td></tr>
                <tr><th>STATUS</th><td>{ticket.status_title}</td></tr>
                <tr><th>RESOLUTION</th><td>{ticket.resolution_title}</td></tr>
                <tr><th>DATE</th><td>{ticket.created_at}</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="col-md-8">
          <ul className="nav nav-tabs">
            {["details", "update", "comments", "files", "workorder", "logs"].map((t) => (
              <li className="nav-item" key={t}>
                <button
                  className={`nav-link ${activeTab === t ? "active" : ""}`}
                  onClick={() => setActiveTab(t)}
                >
                  {t === "update" ? "Update Status" : t.charAt(0).toUpperCase() + t.slice(1)}
                </button>
              </li>
            ))}
          </ul>

          <div className="p-3 border border-top-0">
            {activeTab === "details" && <TicketDetails ticket={ticket} />}

            {activeTab === "update" && (
              <TicketStatusUpdate
                ticketId={id}
                ticket={ticket}
                assetList={assetList}
                statusList={statusList}
                resolutionList={resolutionList}
                getAuthHeader={getAuthHeader}
                onUpdated={loadDetails}
              />
            )}

            {activeTab === "comments" && (
              <TicketComments ticketId={id} getAuthHeader={getAuthHeader} />
            )}

            {activeTab === "files" && (
              <TicketFiles ticketId={id} getAuthHeader={getAuthHeader} />
            )}

            {activeTab === "workorder" && (
              <WorkOrderList workOrders={workOrders} /> // ✅ FIXED
            )}

        {activeTab === "logs" && (
  <TicketLogs ticketId={id} getAuthHeader={getAuthHeader} />
)}


          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketView;
